import { z } from 'zod'
import { mcpActorKindSchema } from '../enums/actor-kind.enum.js'
import { requestSourceSchema } from '../enums/request-source.enum.js'
import { tenantModeSchema } from '../enums/tenant-mode.enum.js'
import { uuidSchema } from '../validators/params.js'

export { mcpActorKindSchema }

/** One machine-API request as the dashboard's request log lists it. */
export const apiRequestDtoSchema = z.object({
  id: uuidSchema,
  requestId: z.string(),
  mode: tenantModeSchema,
  method: z.string(),
  path: z.string(),
  status: z.number().int(),
  durationMs: z.number().int().nonnegative(),
  /** The API key that made the request; null for an MCP action a person took. */
  key: z.object({ id: uuidSchema, name: z.string(), prefix: z.string() }).nullable(),
  source: requestSourceSchema,
  /** For an MCP tool call: the tool, who called it, and the AI app it came through. */
  mcp: z
    .object({
      tool: z.string(),
      actor: z.object({ kind: mcpActorKindSchema, name: z.string() }),
      app: z.string().nullable(),
    })
    .nullable(),
  ip: z.string().nullable(),
  errorCode: z.string().nullable(),
  createdAt: z.string().datetime(),
})

export type ApiRequestDto = z.infer<typeof apiRequestDtoSchema>

export const apiRequestListDtoSchema = z.object({
  requests: z.array(apiRequestDtoSchema),
  /** Pass as `before` for the next (older) page; null when there are no more. */
  nextBefore: z.string().nullable(),
})

export type ApiRequestListDto = z.infer<typeof apiRequestListDtoSchema>

/** One request with its bodies (test mode only; always null for live requests). */
export const apiRequestDetailDtoSchema = apiRequestDtoSchema.extend({
  requestBody: z.string().nullable(),
  responseBody: z.string().nullable(),
})

export type ApiRequestDetailDto = z.infer<typeof apiRequestDetailDtoSchema>
